// Peripheral card software update on SMRs / connectors, its execution is tracked per unit instead of per charger
export const isUnitLevelCommand = (command?: string | null, scope?: UpdateCommandScope | null): boolean => {
  return command === 'ftp_peripheral_card_sw_update' && !!scope && scope !== 'Charger';
};

// Charger, all SMRs / connectors (target unit 0) or the SMR / connector number the command is sent to
export const getScopeLabel = (scope?: UpdateCommandScope | null, targetUnit?: number | null): string => {
  if (!scope || scope === 'Charger') return 'Charger';
  return targetUnit ? scope + ' ' + targetUnit : 'All ' + scope + 's';
};

// First charger / customer of the command with the count of the rest, e.g. "Test_112233 +3"
export const getFirstWithRestCountLabel = (first?: string | null, count?: number | null): string => {
  return (first ?? '') + ((count ?? 0) > 1 ? ' +' + ((count ?? 0) - 1) : '');
};
